export default __webpack_public_path__ + "static/automazione-ai-smart-contract-fcb5ab56c278591629bdc9a060f55a90.png";